<template>
  <div class="page_header">
    <img src="../../img/m/header_arrow_right.png" alt="" class="arrow" @click="goLink()">
    <span class="name">{{name}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
        
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  methods: {
    goLink () {
      if (this.page == 'userinfo') {
        this.$router.push({
          path: '/mpage/m_home'
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page_header {
  background: #fff;
  padding: .33rem 0 .33rem .5rem;
  // position: fixed;
  // width: 100%;
  .arrow {
    width: .39rem;
    margin-right: .65rem;
  }
  .name {
    font-size: .8rem;
  }
}
</style>
